import { render } from "./ChartShowcase.vue?vue&type=template&id=65353d60"
import script from "./ChartShowcase.vue?vue&type=script&lang=js"
export * from "./ChartShowcase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__